import React from "react";
import { Tooltip } from "@/components/common/Tooltip";

interface ColumnFormatBadgeProps {
  /** Short pill text shown in the column row (e.g. "UTC", "Date only", ".2"). */
  label: string;
  /** Shown on hover. */
  tooltip: React.ReactNode;
  /** Optional click handler. When provided, the badge is rendered as a clickable
   *  affordance (cursor + underline-on-hover); when omitted, it's a static label. */
  onClick?: () => void;
}

/** A single accent-colored pill badge in a column row. Shared by the timezone,
 *  format, and decimal-places badges so they all stay visually identical and
 *  stop drifting in copy/paste-land. */
export const ColumnFormatBadge: React.FC<ColumnFormatBadgeProps> = ({
  label,
  tooltip,
  onClick,
}) => {
  const className = onClick
    ? "text-mono-small text-accent cursor-pointer hover:underline pointer-events-auto"
    : "text-mono-small text-accent";
  const handleClick = onClick
    ? (e: React.MouseEvent) => {
        e.stopPropagation();
        onClick();
      }
    : undefined;
  return (
    <Tooltip title={tooltip}>
      <span className={className} onClick={handleClick}>
        {label}
      </span>
    </Tooltip>
  );
};
